import React, { Component } from "react";
import { Button, Checkbox, Input, Modal, Radio,InputNumber,message,Form,Row,Col } from "antd";
import { withRouter } from "react-router-dom";
import Apis from "src/js/apis/api";

import "./index.css";
import Utils from "src/js/utils";

import ReactEcharts from 'echarts-for-react';
import 'echarts-gl';
import { min } from "echarts-gl";
const FormItem = Form.Item;


@withRouter
class TaxonomyTableResult extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ResultVisible: false,
      detailData: {},
      showDetailForm: false,
      taxType: "Original",
      isCheckAll: false,
      checkedObj: {},
      defaultCheckedList: [],
      searchParams: props.searchParams || {},
      searchValues: props.searchValues || {},
      currentPage: 1,
      totalNumbers: 0,
      resultLists: [],
      pageSize: 16,
      AllPages: 0,
      checkOne: props.checkOne === true ? true : false,
      embellish: {},
      disableCheck: props.disableCheck === true ? true : false,
      fossilistObj: props.fossilistObj || {},
      ChildIdsObj: props.ChildIdsObj || {},
      parentObj: props.parentObj || {},
      disabledObj: {},
      // askLoading: false,

      showSiblings: props.showSiblings || false,
      scatter3D:false,
      scatter3DData:[],
      chartsModal:false,
      scatter3DAttribute:[]
    };
  }
  componentDidMount() {
    let { ChildIdsObj, parentObj } = this.state;
    if (this.props.onTaxonomy) {
      this.props.onTaxonomy(this);
    }

    if (this.props.checkOne) {
      this.setState({
        checkOne: true
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      searchParams: nextProps.searchParams,
      searchAllValues: nextProps.searchAllValues
    });
    if (this.props.checkOne) {
      this.setState({
        checkOne: true
      });
    }
    if (nextProps.showDeleteSubset!==this.props.showDeleteSubset) {
      this.setState({
        showDeleteSubset: nextProps.showDeleteSubset
      });
    }
    if (nextProps.showAddSubset!==this.props.showAddSubset) {
      this.setState({
        showAddSubset: nextProps.showAddSubset
      });
    } 
    if (nextProps.showSiblings!==this.props.showSiblings) {
      this.setState({
        showSiblings: nextProps.showSiblings
      });
    } 
  }

  searchTaxonomyDatas = async (
    searchParams,
    searchAllValues,
    embellish,
    taxonType,parameter1,parameter2,page
  ) => {
    if(page==undefined){
      this.setState({
        currentPage:1
      })
      
    }
    this.setState({
      searchParams,
      searchAllValues,
      embellish,
      taxonType,
      askLoading:true,
      checkedObj:{}
    },async()=>{
      let searchResult = [];
      let searchCondition = {};
      let pageParams = {
        page: this.state.currentPage,
        pageSize: this.state.pageSize
      };
  
      Object.assign(searchCondition, searchParams, pageParams);
      let {showSiblings}=this.state
      if(showSiblings){
    
        searchResult = await Apis.searchTaxonBrothers(searchCondition);
      }else{
        searchResult = await Apis.getTaxons(searchCondition);
      }
  
      
      if (searchResult.error) {
        this.setState({
          askLoading:undefined
        })
        Modal.error({
          title: "This is an error message",
          content: searchResult.error
        });
      } else if (searchResult.result) {
        let result = searchResult.result;
        let totalNumbers = searchResult.total;
        let { pageSize } = this.state;
        let AllPages = Math.ceil(totalNumbers / pageSize);
        this.setState(
          {
            resultLists: result,
            totalNumbers,
            AllPages,
            conditions: searchAllValues,
            askLoading:false
          },
          () => {}
        );
      }
    });
   
  };
  changePage = value => {
    this.setState(
      {
        currentPage: value,
        isCheckAll: false,
        askLoading:undefined,
        checkedObj:{},
        resultLists:[]

      },
      () => {
        let { searchParams, values, embellish, taxonType } = this.state;
        this.searchTaxonomyDatas(searchParams, values, embellish, taxonType,'','',this.state.currentPage);
      }
    );
  };
  gotoPage = e => {
    if (e.keyCode === 13) {
      var page = parseInt(e.target.value);

      let { AllPages } = this.state;
      if (page < 1 || page > AllPages) {
        message.warning("Please enter the correct page number");
        return;
      } else {
        this.setState(
          {
            currentPage: page
          },
          () => {
            this.changePage(this.state.currentPage);
          }
        );
      }
    }
  };
  gotoPages=()=>{
    let pageDom=document.querySelector('.searchResult-select input')
    if(pageDom){
      let pageValue=pageDom.value
      if(pageValue){
        let  page= parseInt(pageValue);
        let { AllPages } = this.state;
        if (page < 1 || page > AllPages) {
           message.warning("Please enter the correct page number");
          return;
        } else {
          this.setState(
            {
              currentPage: page
            },
            () => {
              this.changePage(this.state.currentPage);
            }
          );
        }

      }
    }

  }
  toFirst = e => {
    this.setState(
      {
        currentPage: 1
      },
      () => {
        this.changePage(this.state.currentPage);
      }
    );
  };

  toPre = e => {
    if (this.state.currentPage === 1) {
      return;
    } else {
      this.setState(
        {
          currentPage: this.state.currentPage - 1
        },
        () => {
          this.changePage(this.state.currentPage);
        }
      );
    }
  };

  toNext = e => {
    if (this.state.currentPage === this.state.AllPages) {
      return;
    } else {
      this.setState(
        {
          currentPage: this.state.currentPage + 1
        },
        () => {
          this.changePage(this.state.currentPage);
        }
      );
    }
  };

  CheckAll = e => {
    let { resultLists, checkedObj, disabledObj, parentObj } = this.state;
    let parentIdObj = {};
    if (JSON.stringify(parentObj) !== "{}") {
      parentIdObj = {
        [parentObj.id]: parentObj.id
      };
    }
    let allDisabledObj = Object.assign({}, disabledObj, parentIdObj);
    this.setState({
      disabledObj: allDisabledObj
    });
    // if(JSON.stringify(disabledObj)!=="{}"){
    //   this.setState({
    //     isCheckAll:false
    //   })
    //   return
    // }

    if (e.target.checked === true) {
      this.setState(
        {
          isCheckAll: true
        },
        () => {
          resultLists.map((item, index) => {
            if (allDisabledObj[item.id] === undefined) {
              checkedObj[item.id] = item;
            }
          });
          this.setState(
            {
              checkedObj
            },
            () => {
              let { checkedObj, resultLists } = this.state;
              if(this.props.changeCheckSelected){
                this.props.changeCheckSelected(checkedObj, resultLists);
              }

              
            }
          );
        }
      );
    } else {
      this.setState(
        {
          isCheckAll: false
        },
        () => {
          this.setState(
            {
              checkedObj: {}
            },
            () => {
              let { checkedObj, resultLists } = this.state;
              if( this.props.changeCheckSelected){
                this.props.changeCheckSelected(checkedObj, resultLists);
              }
              }
           
          );
        }
      );
    }
  };

  itemCheckbox = (item, index, event, combinationName) => {
    if (this.props.location.search) {
      this.setState(
        {
          isSearch: true
        },
        () => {
          // this.props.history.push('')
        }
      );
    } else {
      this.setState({
        isSearch: false
      });
    }

    let { resultLists, checkedObj, fossilistObj } = this.state;

    if (event.target.checked === true) {
      checkedObj[item.id] = item;
    } else if (
      event.target.checked === false &&
      checkedObj[item.id]
    ) {
      delete checkedObj[item.id];
    }

    let checkedLength = Object.keys(checkedObj).length;
    this.setState(
      {
        isCheckAll: checkedLength === resultLists.length
      },
      () => {
        if (this.props.checkOne) {
          // if(fossilistObj.hasOwnProperty(item.id)){
          //   Modal.info({
          //     content:'This resource has been added,Please re-select'
          //   })
          //   return
          // }

          this.props.checkTaxonomyOne(item, combinationName);
        } else {
          let { checkedObj, resultLists } = this.state;
          if( this.props.changeCheckSelected){
            this.props.changeCheckSelected(checkedObj, resultLists);
          }
          
        }
      }
    );
  };

  getDetail = detailItem => {
    this.props.getDetail(detailItem);
  };
  getExtraData = itemValue =>{
    this.props.getExtraData(itemValue);
  }
  resetCheckData=()=>{
    this.setState({
      currentPage: 1,
      isCheckAll: false,
      askLoading:undefined,
      checkedObj:{}
    })
  }

  showScatter3D=async()=>{
    // console.log("checkedObj:"+this.state.checkedObj);
    
    this.setState(
      {
        scatter3D: true
      });
  }

  scatter3DModelOk = () => {
    this.setState({
      scatter3D: false,
      scatter3DAttribute:[]
    });
  };

  scatter3DModelCancel = () => {
    this.setState({
      scatter3D: false,
      scatter3DAttribute:[]
    });
  };

  checkGroupChange=(selectedList)=>{
    if(selectedList.length>3){
      // alert("You can only select up to 3 options.");
      message.error('最多只能选择3个选项！');
    }
    // else{
    //   for (var element of selectedList) {
    //     console.log(element);
    //   }
    // }
    // console.log("length:"+selectedList.length);

    this.setState({
      scatter3DAttribute:selectedList
    })
  }

  scatter3DModelConfirm=async()=>{
    let taxonomy_attribute=this.state.scatter3DAttribute

    // console.log("attribute:"+taxonomy_attribute.length);
    
    if(taxonomy_attribute.length!=3){
      this.setState(
        {
          scatter3D: false
        });
      Modal.error({
        content: "Please select 3 attributes!"
      });
    }else{
      this.setState(
        {
          scatter3D: false
        });
      let { checkedObj } = this.state;
      let taxonmy_ids = Object.keys(checkedObj);
      let params ={"taxonomy_attribute":taxonomy_attribute,"taxonmy_ids":taxonmy_ids,"checkedObj":checkedObj};
      let downBack=await Apis.searchExForScatter3D(params);

      if(downBack.result!=null){
        let scatter3DData=downBack.result
        if(scatter3DData.length!=0){
          this.setState({
            chartsModal:true,
            scatter3DData:scatter3DData
          })
        }else{
          alert("No data find!");
        }
      }else {
        Modal.error({
          content: "Fail"
        });
      }
      
    }
  }

  chartsModelOk = () => {
    this.setState({
      chartsModal: false,
      scatter3DData:[],
      scatter3DAttribute:[]
    });
  };

  chartsModelCancel = () => {
    this.setState({
      chartsModal: false,
      scatter3DData:[],
      scatter3DAttribute:[]
    });
  };
  
  render() {
    let { getFieldDecorator } = this.props.form;
    let {
      currentPage,

      AllPages,
      isCheckAll,
      checkedObj,

      checkOne,
      disableCheck,
      ChildIdsObj,
      parentObj,
      disabledObj,
      resultLists,
      embellish
    } = this.state;

    const taxonmy_ex_data={
      body_size:4,
      feeding_mode:7,
      mobility:6,
      morphology:4,
      tiering:6,
      rigidity:4,
      reproduction:2,
      growth_form:2,
      structural_fragility:3,
      larval_type:5,
      trophic_level:3,
      sediment_stabiliser:3
    }

    let chartsOption={
      tooltip: {
        trigger: 'item', // 触发类型，默认数据项触发，支持 'item' | 'axis'
        formatter: function (params) {
          // console.log(params);
          let result=params.name.join('<br>');
            // params 是一个包含数据信息的对象，可以根据需要进行格式化
          return result; // 假设最ssss后一个值为点的名称
        }
      },
      toolbox:{
        show: true,
        feature: {
          saveAsImage: {}  // 导出图片
        }
      },
      xAxis3D: {
        name:this.state.scatter3DAttribute[0],
        axisLine: {
            lineStyle: {
                color:'#FF0000' // 红色
            }
        },
        type:"value",
        // data:taxonmy_ex_data[this.state.scatter3DAttribute[0]]
        min:0,
        interval:1,
        max:taxonmy_ex_data[this.state.scatter3DAttribute[0]]
      },
      yAxis3D: {
        name:this.state.scatter3DAttribute[1],
        axisLine: {
              lineStyle: {
                  color: '#00FF00' // 绿色
              }
        },
        type:"value",
        // data:taxonmy_ex_data[this.state.scatter3DAttribute[1]]
        min:0,
        interval:1,
        max:taxonmy_ex_data[this.state.scatter3DAttribute[1]]
      },
      zAxis3D: {
        name:this.state.scatter3DAttribute[2],
        axisLine: {
            lineStyle: {
                color: '#0000FF' // 蓝色
            }
        },
        type:"value",
        // data:taxonmy_ex_data[this.state.scatter3DAttribute[2]]
        min:0,
        interval:1,
        max:taxonmy_ex_data[this.state.scatter3DAttribute[2]]
      },
      // xAxis3D: {name:this.state.scatter3DAttribute[0],data:['xa','xb','xc','xd','xe']},
      // yAxis3D: {name:this.state.scatter3DAttribute[1],data:['ya','yb','yc','yd','ye']},
      // zAxis3D: {name:this.state.scatter3DAttribute[2],data:['za','zb','zc','zd','ze']},
      grid3D: {},
      series: [{
          type: 'scatter3D',
          dimensions:[this.state.scatter3DAttribute[0],this.state.scatter3DAttribute[1],this.state.scatter3DAttribute[2]],
          data: this.state.scatter3DData,
          label: {
            show: false,
            formatter:''
          },
          // emphasis: {
          //   label: {
          //       show: true, // 鼠标悬停时显示标签
          //       formatter:'{b}'
          //   }
          // },
          // data: [['xb','ya','zb'],
          // ['xd','yb','zc'],
          // ['xc','yc','zb'],],
          // [
          //     [10, 10, 10], // X, Y, Z坐标点，可以根据需要增加更多点
          //     [20, 20, 20],
          //     // ...更多点
          // ],
          encode: {
            x: this.state.scatter3DAttribute[0],
            y: this.state.scatter3DAttribute[1],
            z: this.state.scatter3DAttribute[2]
          },
          symbolSize: 10, // 点的大小
      }]
  };

    return (
      <div id="SearchResult" className="SearchResult-refsearch">
        {/*  taxResult-main */}
        <div className="">
          <div className="content">
            {resultLists.length > 0 &&this.state.askLoading==false? (
              <table>
                <tbody>
                  <tr className="head">
                    {this.state.showSiblings?
                          null
                          :
                    checkOne && disableCheck === false ? (
                      <td></td>
                    ) : disableCheck === true ? null : (
                      <td className="check">
                        <Checkbox
                          onChange={e => this.CheckAll(e, "id")}
                          checked={isCheckAll == true}
                          title="Some resources have been added"
                        ></Checkbox>
                      </td>
                    )}

                    <td>Taxon ID</td>
                    <td>Fossil group</td>
                    <td className="ref-id">Taxon type</td>
                    <td>Taxon name</td>
                    <td>Described in</td>
                    <td>Enterer</td>
                    <td>Details</td>
                    <td>Functional traits</td>
                    {/* <td>Details</td> */}
                  </tr>

                  {resultLists.map((item, index) => {
                    let taxonName1 = item.taxon_name1;
                    let taxonName2 = item.taxon_name2;
                    let genusPrefix = embellish ? embellish.genusPrefixV : "";
                    let spPrefix1 = embellish ? embellish.spPrefix1V : "";
                    let spPrefix2 = embellish ? embellish.spPrefix2V : "";
                    let spNameDict = embellish ? embellish.spDictV : "";
                    let spSuffix = embellish ? embellish.spSuffixV : "";
                    let Name = Utils.fullName(
                      taxonName1,
                      taxonName2,
                      genusPrefix,
                      spPrefix1,
                      spPrefix2,
                      spNameDict,
                      spSuffix
                    );
                    if (
                      ChildIdsObj.hasOwnProperty(item.id) ||
                      parentObj.id === item.id
                    ) {
                      disabledObj[item.id] = item.id;
                    }
                    return (
                      <tr key={item.id} className="row">
                        {
                          this.state.showSiblings?
                          null
                          :
                        !disableCheck && checkOne ? (
                          <td className="check">
                            <Radio
                              name={(item.id).toString()}
                              datavalue={item}
                              onChange={event =>
                                this.itemCheckbox(item, index, event, Name)
                              }
                              checked={checkedObj.hasOwnProperty(item.id)}
                            ></Radio>
                          </td>
                        ) : !disableCheck && !checkOne ? (
                          <td className="check">
                            <Checkbox
                              name={(item.id).toString()}
                              datavalue={item}
                              onChange={event =>
                                this.itemCheckbox(item, index, event, Name)
                              }
                              checked={checkedObj.hasOwnProperty(item.id)}
                              disabled={
                                ChildIdsObj.hasOwnProperty(item.id) ||
                                parentObj.id === item.id
                              }
                            ></Checkbox>
                          </td>
                        ) : null}

                        <td>{item.id}</td>
                        <td>{item.fossil_group}</td>

                        <td>{item.taxon_type}</td>
                        <td>{Name}</td>
                        <td>{`(ID = ${item.ref_id})`}</td>
                        <td>{item.enterer_username}</td>

                        <td className="btn">
                          <Button
                            type="gbdb"
                            onClick={() => this.getDetail(item)}
                          >
                            <div>Details</div>
                          </Button>
                        </td>
                        <td className="btn">
                          <Button
                            type="gbdb"
                            onClick={() => this.getExtraData(item)}
                          >
                            <div>Functional Traits</div>
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )   
            :
            this.state.askLoading==true?
            (
              <div className="tablelist-no-resource"> <div id="allResult">
                      <div className="allLoader">
                        <div className="loader-inner ball-spin-fade-loader">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        <span>Loading...</span>
                      </div>
                    </div></div>
            )
            :
            resultLists.length ===0 &&this.state.askLoading==false?
            (
              <div className="tablelist-no-resource">No Resource</div>
            )
            :
            <div className="tablelist-no-resource"></div>
          }
          </div>
          {resultLists.length > 0 ? (
            <div className="footer">
              <div className="first" onClick={this.toFirst}>
                First
              </div>
              <div className="pre" onClick={this.toPre}>
                Pre
              </div>
              <div className="pages">{`${currentPage}/${AllPages}pages`}</div>
              <div className="next" onClick={this.toNext}>
                Next
              </div>

              <div className="page-input">
              <InputNumber
                  className="searchResult-select"
                  onKeyDown={this.gotoPage}
                  min={1}
                ></InputNumber>
                  <span className="goto" onClick={this.gotoPages}>Goto</span>
              </div>
            </div>
          ) : null}
        </div>
        <div className="subset-file-btns">
            <Button
              type="gbdb"
              disabled={Object.keys(checkedObj).length == 0}
              onClick={this.showScatter3D}
            >
              Ecospace
            </Button>
        </div>

        <Modal
          title=""
          destroyOnClose
          visible={this.state.scatter3D}
          className="download-section-modal"
          width="50%"
          footer={null}
          // header={null}
          onOk={this.scatter3DModelOk}
          onCancel={this.scatter3DModelCancel}
        >
          <form>
            <div className="age-model">
              <FormItem label="Functional Traits Attribute">
                <div className="referenceSearch-author">
                  <span style={{width:'100%',display:'grid'}}>                           
                    {getFieldDecorator("taxonomy_ex_attribute", {
                      initialValue: []
                    })(
                        <Checkbox.Group style={{width:'100%'}}  onChange={this.checkGroupChange}>
                          <Row>
                            <Col span={3}>
                              <Checkbox value="body_size">body_size</Checkbox>
                            </Col>
                            <Col span={4}>
                              <Checkbox value="feeding_mode">feeding_mode</Checkbox>
                            </Col>
                            <Col span={3}>
                              <Checkbox value="mobility">mobility</Checkbox>
                            </Col>
                            <Col span={3}>
                              <Checkbox value="morphology">morphology</Checkbox>
                            </Col>
                            <Col span={3}>
                              <Checkbox value="tiering">tiering</Checkbox>
                            </Col>
                            <Col span={3}>
                              <Checkbox value="rigidity">rigidity</Checkbox>
                            </Col>
                            <Col span={3}>
                              <Checkbox value="reproduction">reproduction</Checkbox>
                            </Col>
                            <Col span={3}>
                              <Checkbox value="growth_form">growth_form</Checkbox>
                            </Col>
                            <Col span={5}>
                              <Checkbox value="structural_fragility">structural_fragility</Checkbox>
                            </Col>
                            <Col span={3}>
                              <Checkbox value="larval_type">larval_type</Checkbox>
                            </Col>
                            <Col span={3}>
                              <Checkbox value="trophic_level">trophic_level</Checkbox>
                            </Col>
                            <Col span={5}>
                              <Checkbox value="sediment_stabiliser">sediment_stabiliser</Checkbox>
                            </Col>
                          </Row>
                        </Checkbox.Group>
                    )}
                  </span>
                </div>
              </FormItem>
            </div>
          </form>

          <div className="download-section-btns">
            <Button type="gbdb" onClick={this.scatter3DModelConfirm}>
              Confirm
            </Button>
          </div>
        </Modal>

        <Modal
          title="Ecospace"
          destroyOnClose
          visible={this.state.chartsModal}
          className="download-taxon-modal"
          bodyStyle={{ height: "600px" }}
          width="60%"
          // style={{ height: '700px' }}
          footer={null}
          // header={null}
          onOk={this.chartsModelOk}
          onCancel={this.chartsModelCancel}
          >
          <div style={{height:'100%'}}>
          <ReactEcharts option={chartsOption} style={{height:"100%"}}></ReactEcharts>
          </div>
          
        </Modal>
      </div>
    );
  }
}

TaxonomyTableResult = Form.create({})(TaxonomyTableResult);
export default TaxonomyTableResult;
